module.exports = __webpack_public_path__ + "static/media/quote-vector.16fd488b.svg";